import React, { ReactNode } from 'react';
import './truncated-list.scss';

interface Props<ItemType> {
  itemCount: number;
  itemKey: (item: ItemType) => string;
  items: ItemType[];
  renderItem: (item: ItemType) => ReactNode;
  size: number;
}

function TruncatedList<ItemType>(props: Props<ItemType>) {
  const { itemCount, itemKey, items, renderItem, size } = props;

  const numItemsRemaining = itemCount - size;

  return (
    <div className="truncated-list">
      {items.slice(0, size).map((item, index) => (
        <div className="truncated-list-item" key={`${index}-${itemKey(item)}`}>
          {renderItem(item)}
        </div>
      ))}
      {numItemsRemaining > 0 && <div>{`(+ ${numItemsRemaining} more)`}</div>}
    </div>
  );
}

export default TruncatedList;
